import React from 'react';

/**
 * PiAI03Solid icon from the solid style in ai category.
 */
interface PiAI03SolidProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiAI03Solid({
  size = 24,
  color,
  className,
  ariaLabel = 'ai-03 icon',
  ...props
}: PiAI03SolidProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      
       style={{color: color || "currentColor"}}
      
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path d="M19.574 1.113a1.52 1.52 0 0 0-1.148 0c-.27.11-.456.285-.575.411-.11.117-.228.264-.34.403L16.68 2.97l-.055.067c-.193.24-.457.565-.56.965a2 2 0 0 0 0 .998c.103.4.367.726.56.965l.055.067.833 1.042c.111.139.229.286.339.403a1.52 1.52 0 0 0 1.723.412c.27-.11.456-.286.575-.412.11-.117.228-.264.339-.403l.833-1.042.054-.067c.194-.24.457-.565.561-.965a2 2 0 0 0 0-.998c-.104-.4-.367-.726-.56-.965l-.055-.067-.833-1.042a7 7 0 0 0-.34-.403 1.6 1.6 0 0 0-.574-.411Z" fill="currentColor"/><path d="M10.849 3.374a2 2 0 0 0-1.698 0c-.423.198-.685.552-.862.83-.178.28-.368.65-.58 1.063L6.496 7.621l-.08.153-.002.002-.002.001-.149.088-2.422 1.408c-.36.21-.687.4-.937.577-.254.18-.566.44-.743.839a2 2 0 0 0 0 1.622c.177.4.489.659.743.84.25.177.577.367.937.576l2.422 1.408.15.088h.001l.001.003c.017.03.038.07.08.153l1.212 2.354c.213.413.403.782.581 1.063.177.278.44.632.862.83a2 2 0 0 0 1.697 0c.423-.198.686-.552.862-.83.179-.28.369-.65.582-1.063l1.211-2.354.08-.153.002-.002.002-.001c.028-.018.068-.041.148-.088l2.423-1.408c.36-.21.687-.4.937-.577.254-.18.566-.44.743-.839a2 2 0 0 0 0-1.622c-.177-.4-.49-.659-.743-.84a13 13 0 0 0-.937-.576l-2.423-1.408-.148-.088h-.002l-.002-.003-.08-.153-1.211-2.354a15 15 0 0 0-.582-1.063c-.176-.278-.439-.632-.862-.83Z" fill="currentColor"/>
    </svg>
  );
}
